var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseList',{attrs:{"nested":_vm.nested}},[_vm._t("header"),_vm._t("body-before"),_vm._l((_vm.entities),function(entity,index){return [_vm._t("default",null,{"index":index,"entity":entity})]}),_vm._t("body-after"),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }